<script lang="ts">    
    export let fieldsetClass = '';
    export let labelClass = '';
    export let _for = '';
    export { _for as for };
</script>

<fieldset class={fieldsetClass}>
    {#if $$slots.label}
        <label for={_for} class={labelClass}>
            <slot name="label"></slot>
        </label>
    {/if}
    <slot></slot>
    {#if $$slots.error}
        <span class="text-sm text-vv-red-fire">
            <slot name="error"></slot>
        </span>
    {/if}
</fieldset>